<template>
  <div class="layout-vertical-center">
    <div v-if="verified" class="verified-dialog">
      <el-dialog
        v-model="dialog"
        width="552px"
        center
        @close="handleLogin">
        <div class="text-center" style="color: #272727;">
          <img src="/img/assets/verified/olsera-icon.png" class="mb-32">
          <h4>{{ $t('login.verified') }}</h4>
          <p class="font-14">
            {{ $t('login.verified_message') }}
          </p>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button
              type="success"
              class="mb-32"
              @click="handleLogin">
              {{ $t('login.explore_now') }}
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-else class="verified-dialog">
      <el-dialog
        v-model="dialog"
        width="552px"
        center
        @close="handleLogin">
        <div class="text-center" style="color: #272727;">
          <el-icon :size="60" color="#026DA7" class="mb-20">
            <WarningFilled />
          </el-icon>
          <h4>{{ $t('login.not_verified') }}</h4>
        </div>
        <template #footer />
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { verifyEmail } from '@/api/auth.js'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { WarningFilled } from '@element-plus/icons-vue'

const route = useRoute()
const router = useRouter()
const dialog = ref(true)
const verified = ref(false)
const message = ref(null)

onMounted(() => {
  handleVerified()
})

const handleVerified = () => {
  const params = {
    token: route.query.token
  }
  verifyEmail(params).then((response) => {
    verified.value = true
    message.value = response.data.message
  }).catch((error) => {
    verified.value = false
    message.value = error.message
  })
}
const handleLogin = () => {
  dialog.value = false
  router.push({
    path: '/login'
  })
}
</script>

<style lang="scss">
.verified-dialog {
  & .el-dialog {
    border-radius: 16px !important;
    background: linear-gradient(0.63deg, #F5FCFF 20.73%, #DDF2FA 92.33%);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);
  }
  & .el-button {
    background: #1FAD1F !important;
    width: 198px;
  }
}
</style>
